import React, { useState } from 'react';
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import './community.css';
const Community = () => {
    return (
        <div>
            <Navbar />
            <div className='contenedor-community'>

            </div>
        </div>

    );

};


export default Community;